import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-popup-content',
    templateUrl: './popup-content.component.html',
    styleUrls: ['./popup-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupContentComponent {
  @Input() iconName: string;
  @Input() headline: string;

}
